export const nav = {
    "nav_dashboard": "仪表盘",
    "nav_files": "课件",
    "nav_available_tutors": "课时",
    "nav_working_hours": "工时",
    "nav_class": "班级",
    "nav_my_homework": "我的作业",
    "nav_homeworkBank": "作业库",
    "nav_grade_pending": "待批改",
};

export const weekday = {
    "weekday_1": "星期一",
    "weekday_2": "星期二",
    "weekday_3": "星期三",
    "weekday_4": "星期四",
    "weekday_5": "星期五",
    "weekday_6": "星期六",
    "weekday_7": "星期日",
    "weekday_Workdays": "工作日",
    "weekday_Weekends": "周末",
};

export const userRole = {
    "role_tutor": "Tutor",
    "role_super_admin": "超级管理员",
    "role_academic_tutor": "学术老师",
    "role_manager_admin": "管理员",
    "role_admin": "教务老师",
    "role_consultant": "顾问",
    "role_student": "学生",
};

export const common = {
    "loading": "加载中...",
    "_BaseTitle": "最高校",
    ...nav,
    ...weekday,
    ...userRole,
};
